/**
 * Patch payload for endpoint /api/users/{domain}/updateGuest
 */
export class UpdateGuestUserRequest {
    constructor(
        guestUsers: GuestUser[],
        usingAdminRole: boolean,
        adminJustification: string
    ) {
        this.guestUsers = guestUsers;
        this.usingAdminRole = usingAdminRole;
        this.adminJustification = adminJustification;
    }
    guestUsers: GuestUser[] = [];
    usingAdminRole: boolean = false;
    adminJustification: string = '';
}

export interface GuestUser {
    userId: string,
    givenName: string,
    surname: string,
    stewardUserId?: string,
}